import { NestAPI } from '@marketing-milk/frontend'

/**
 * Re-download the staged import archive (as a Blob) when reopening an
 * awaiting_confirmation import. The Review thumbnails are normally unzipped
 * from the freshly uploaded file; after a refresh that file is gone, so we
 * re-fetch the archive and run it back through the same client-side extractor.
 */
export const fetchStagedArchive = async (
  businessID: number | string,
  creativeImportID: number
): Promise<Blob> => {
  const response = await NestAPI.get<Blob>(
    `businesses/${businessID}/creative-import/${creativeImportID}/archive`,
    { responseType: 'blob' }
  )
  return response.data
}
